import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AttributionFromMAPA } from '../models/AttributionFromMAPA';
@Component({
  selector: 'app-attribution-fromMAPA',
  templateUrl: './attribution-fromMAPA.component.html'
})
export class AttributionFromMAPAComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'AttributionFromMAPA'
  @Input() parentForm: FormGroup;
  	@Input() attributionFromMAPA : AttributionFromMAPA;

  constructor() { }

  public ngOnInit() {
  }








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

